let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l6aOf")).then(() => parcelRequire('ivy3P'));